import React from 'react';
import { connect } from 'react-redux';
import withRouter from "js/withRouter";
import { injectIntl } from "react-intl";
import { has, max, update } from 'lodash';
import { send } from 'react-ga';
import ReactDOM from "react-dom";
import { Button, Col, Row } from "react-bootstrap";
import FormInput from "../../../components/forms/FormInput";
import { Form } from 'react-router-dom';
import notification from 'root/m_a_node_modules/@chedri/base/src/modules/notification';

const ContextModal = ({ children }) => {
  return ReactDOM.createPortal(
    children,
    document.getElementById('context-modal')
  );
};

class RatingElement extends React.Component {

  constructor(props) {
    super(props);
    const { intl: { messages } } = this.props;
    this.state = {
      hoveredRating: 0,
      ratingProvider: '',
      ratingThreshold: 3,
      buttonText: 'Feedback absenden',
      feedbackText: 'Bitte geben Sie uns Ihr Feedback, damit wir uns verbessern können.',
      showModal: false,
      notificationEmail: '',
      emailReceivedMsg: 'Vielen Dank! Ihre Rückmeldung wurde erfolgreich übermittelt.',
    };
  }

  // Sets the hoveredRating to 0 when the mouse leaves the stars area
  handleUnhoverRating = () => {
    this.setState({ hoveredRating: 0 });
  }

  // Sets the hoveredRating to the index of the star being hovered over
  handleHoverRating = (index) => {
    this.setState({ hoveredRating: index + 1 });
  }

  // Helper function to determine if a star should be filled or empty
  isHoveredOrRated = (starIndex) => {
    const { hoveredRating, rating } = this.state;
    return starIndex < (hoveredRating || rating);
  }

  // Sets the state to show the settings modal
  showModal = () => {
    this.setState({ showModal: true });
  }

  // Hides the settings modal and saves the settings
  hideModal = () => {
    this.setState({ showModal: false });
    this.saveSettings();
  }

  // Updates a specific setting in the state used from the input fields within the modal
  settingChanged = (name, value) => {
    this.setState({ [name]: value });
  }

  // Loads the current settings from props into the state when the component mounts or updates
  componentDidMount() {
    this.loadSettings();
  }

  // Loads settings when props change
  componentDidUpdate(prevProps) {
    // Load settings if params have changed
    if (prevProps.params !== this.props.params) {
      this.loadSettings();
    }
  }

  // Loads the current settings from props into the state
  loadSettings = () => {
    const { params, attributes } = this.props;
    const param = params.find(p => p.name === attributes['data-name']);
    if (param) {
      const values = param.value.split('#aaa#');
      this.setState({
        ratingProvider: values[0] || '',
        ratingThreshold: values[1] || 3,
        buttonText: values[2] || 'Feedback absenden',
        feedbackText: values[3] || 'Bitte geben Sie uns Ihr Feedback, damit wir uns verbessern können.',
        notificationEmail: values[4] || '',
        emailReceivedMsg: values[5] || 'Vielen Dank! Ihre Rückmeldung wurde erfolgreich übermittelt.',
      });
    }
  }

  // Saves the current settings from the state back to props
  saveSettings = () => {
    const { ratingProvider, ratingThreshold, buttonText, feedbackText, notificationEmail, emailReceivedMsg } = this.state;
    const { id, attributes, updateParam } = this.props;

    const dataToSave = `${ratingProvider}#aaa#${ratingThreshold}#aaa#${buttonText}#aaa#${feedbackText}#aaa#${notificationEmail}#aaa#${emailReceivedMsg}`;

    const overflow = false;
    const default_image = false;
    const errors = [{ overflow, default_image }];
    updateParam(id, attributes['data-name'], dataToSave, errors);
  }

  // Renders the rating element in the editor (not the actual rating functionality)
  render() {
    const { name: Tag, attributes } = this.props;
    const { ratingProvider, ratingThreshold, buttonText, feedbackText, notificationEmail, emailReceivedMsg } = this.state;
    const { intl: { messages } } = this.props;
    const maxStars = 5;

    return (
      <>
        <Tag {...attributes}>
          <div className='stars-rating-element'>
            <div className='stars' onMouseLeave={this.handleUnhoverRating}>
              {[...Array(maxStars)].map((_, i) => (
                <span
                  className={this.isHoveredOrRated(i) ? 'star filled' : 'star empty'}
                  key={i}
                  id={`star-${i}`}
                  onMouseOver={() => this.handleHoverRating(i)}
                >&#9733;</span>
              ))}
            </div>
          </div>
          <button className="configBtn" onClick={this.showModal}>
            <i className="fa fa-cog" aria-hidden="true"></i>
          </button>
        </Tag>
        {this.state.showModal && (
          <ContextModal>
            <div id="contextModalWrap">
              <div id="contextModalStage" className="row">
                <div className="modal-header">
                  <h5 className="modal-title">{messages.editor.rating_settings}</h5>
                  <button type="button" className="close" onClick={this.hideModal}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <FormInput
                    name="ratingProvider"
                    label={messages.editor.rating_provider_url}
                    value={ratingProvider}
                    onChange={this.settingChanged}
                  />
                  <FormInput
                    name="ratingThreshold"
                    label={messages.editor.rating_threshold}
                    type="number"
                    min="1"
                    max="5"
                    value={ratingThreshold}
                    onChange={this.settingChanged}
                  />
                  <FormInput
                    name="buttonText"
                    label={messages.editor.rating_button_text}
                    value={buttonText}
                    onChange={this.settingChanged}
                  />
                  <FormInput
                    name="feedbackText"
                    label={messages.editor.rating_feedback_text}
                    value={feedbackText}
                    onChange={this.settingChanged}
                  />
                  <FormInput
                    name="notificationEmail"
                    label={messages.editor.rating_feedback_notification_email}
                    type="email"
                    value={notificationEmail}
                    onChange={this.settingChanged}
                  />
                  <FormInput
                    name="emailReceivedMsg"
                    label={messages.editor.rating_email_received_message}
                    value={emailReceivedMsg}
                    onChange={this.settingChanged}
                  />
                </div>
                <div className="modal-footer">
                  <Button variant="secondary" onClick={this.hideModal}>
                    {messages.editor.rating_modal_close_button}
                  </Button>
                  <Button variant="primary" onClick={this.hideModal}>
                    {messages.editor.rating_modal_save_button}
                  </Button>
                </div>
              </div>
            </div>
          </ContextModal>
        )}
      </>
    );
  }
}

// Redux mappings
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

// Export the component wrapped with Redux and Router
export default withRouter(
  injectIntl(
    connect(mapStateToProps)(RatingElement)
  )
);